<div class="stock-tags-container no-select">
    <div class="widget-div">

    @if (canStockTagsBeViewed) {
      <app-shared-widget-container-component>
        <div title class="widget-div-heading">
          <app-display-icon
              [tooltip]="canStockTagsBeEdited ? tooltips.editAccessGranted : tooltips.editAccessDenied"
              [icon]="canStockTagsBeEdited ? icons.lockOpenOutline : icons.lockClosedOutline">
          </app-display-icon>
          <div>Stock Tags</div>
          <app-display-icon
            [tooltip]="tooltips.tagValidTypes"
            [icon]="icons.infoSlabCircleOutline"
            [colour]="iconColours.secondary">
          </app-display-icon>
        </div>
        <div block>
          <form [formGroup]="formStockTags">

            @if (formStockTags?.controls['tags']) {
              <div class="form-column min-width">
                <div class="form-control-div">
                  <div class="label-with-icon">
                    <label for="stock-tags">Tags</label>

                  </div>
                  <app-shared-custom-select
                    id="stock-tags"
                    (selectionChange)="onTagsChange($event)"
                    [allowAddNew]="true"
                    [allowMultiple]="true"
                    [allowSelectAll]="true"
                    [formatSearchText]="formatTagText"
                    [maxLength]="15"
                    [placeholder]="'Select tags...'"
                    [searchPlaceholder]="'Search or add tag...'"
                    [selected]="tagsSelected()"
                    [setOptions]="getTagOptions()"
                    [showChips]="false"
                    [showSearchBar]="true">
                  </app-shared-custom-select>
                  @if (isTagInvalid() && tagErrorMessage()) {
                    <div class="error-message">
                      {{ tagErrorMessage() }}
                    </div>
                  }
                </div>
              </div>
            }

          </form>
        </div>
        <div actions class="widget-actions">
          @if (hasStockTagsBeenEdited) {
            <button
              type="button"
              class="action-button"
              [disabled]="canStockTagsBeEdited === false"
              (click)="onRevertForm('stockTags')">
              <app-display-icon
                [colour]="canStockTagsBeEdited === false ? iconColours.disabled : iconColours.secondary"
                [tooltip]="tooltips.undoChanges"
                [icon]="icons.undo">
              </app-display-icon>
            </button>
          }
          @if (canStockTagsBeSubmitted) {
            <button
              type="button"
              class="action-button"
              [disabled]="isStockTagsSubmitDisabled"
              (click)="onSubmitForm('stockTags')">
              <app-display-icon
                [colour]="isStockTagsSubmitDisabled ? iconColours.disabled : iconColours.secondary"
                [tooltip]="tooltips.saveChanges"
                [icon]="icons.contentSaveOutline">
              </app-display-icon>
            </button>
          }
        </div>
      </app-shared-widget-container-component>
    }

  </div>

  <div class="ups-container-action-bar widget-actions">
    @if (hasStockTagsErrors?.length > 0) {
      @for (field of hasStockTagsErrors; track $index) {
        <button
          type="button"
          class="error-button">
          <app-display-icon
            [colour]="iconColours.red"
            [tooltip]="field?.error"
            [icon]="icons.alertRhombusOutline">
          </app-display-icon>
        </button>
      }
    }
      <button
        [disabled]="!haveAnyEditsBeenMade"
        type="button"
        class="action-button"
        (click)="onRevertForm('all')">
        <app-display-icon
          [colour]="iconColours.secondary"
          [tooltip]="tooltips.undoAllChanges"
          [icon]="icons.undo">
        </app-display-icon>
        Undo Changes
      </button>
      <button
        [disabled]="!haveAnyEditsBeenMade"
        type="button"
        class="action-button"
        (click)="onSubmitForm('all')">
        <app-display-icon
          [colour]="iconColours.secondary"
          [tooltip]="tooltips.saveAllChanges"
          [icon]="icons.contentSaveOutline">
        </app-display-icon>
        Save All
      </button>
  </div>

</div>
